// *********** FILE NAME ***********

export const maxFileName = 15;
export const textTruncate = (text) => {
	if (text.length <= maxFileName) return text;
	return text.slice(0, maxFileName - 3).concat('...');
};

// *********** LOCAL STORAGE ***********
// Api does not allow to fetch recently uploaded file's name.
// To be able to display this value, it's stored in the local storage

const DOCUMENT_VERIFY_FILE_NAME = 'document_verification_file_name';

export const saveToLocalStorage = (fileName) => {
	window.localStorage.setItem(DOCUMENT_VERIFY_FILE_NAME, fileName);
};

export const getFromLocalStorageOrPlaceholder = (placeholder) => {
	return localStorage.getItem(DOCUMENT_VERIFY_FILE_NAME) ?? placeholder;
};

export const clearLocalStorage = () => {
	localStorage.removeItem(DOCUMENT_VERIFY_FILE_NAME);
};
